import { AvailabilityCalculationResult } from "@gymflow/types";
import { AxiosInstance } from "axios";

export type CustomerAvailabilityApiType = ReturnType<
  typeof customerAvailabilityApi
>;

const customerAvailabilityApi = (
  axiosInstance: AxiosInstance,
  clubId: number,
) => {
  const clubPrefix = `club/${clubId}/`;

  return {
    hostCalculateAvailability(params: {
      appointableId: number;
      dateFrom: string;
      dateTo: string;
      hostsIdList?: string[];
      appointmentIdToIgnore?: number;
    }) {
      return axiosInstance.post<AvailabilityCalculationResult[]>(
        `${clubPrefix}customer/availability/host/calculate`,
        params,
      );
    },
    facilityCalculateAvailability(params: {
      appointableId: number;
      dateFrom: string;
      dateTo: string;
      hostsIdList?: string[];
      facilityIdList?: number[];
      appointmentIdToIgnore?: number;
    }) {
      return axiosInstance.post<AvailabilityCalculationResult[]>(
        `${clubPrefix}customer/availability/facility/calculate`,
        params,
      );
    },
  };
};

export default customerAvailabilityApi;
